<template>
    <div>
        <DetailHeader
            title="SD-WAN技术如何提高企业网络沟通效率"
            subTitle="2020-08-14"
        />
        <DetailBody>
            <p class="reveal-bottom">
                几十年来企业通过部署DDN, Frame
                Relay和MPLS等广域网技术保证其商业数据的高质量转发。近年，随着云架构DC和混合架构DC的广泛应用，同时大数据和实时商业数据传输的需求越来越多，传统的专线连接技术已经不能满足客户快速部署商业应用和连接的需求。
            </p>
            <p class="reveal-bottom">
                然而远距离和高质量的实时数据传输需求不应该成为驱动商业快速反应的瓶颈，SDWAN技术可以帮助企业客户实现广域网连接的快速部署，不管是通过Internet还是MPLS，客户都能获得超高速的高质量数据传输服务。
            </p>
            <h3 class="reveal-bottom">
                SD-WAN具有的优势
            </h3>
            <p class="reveal-bottom">
                <span style="font-weight:bold"> 交付周期短：<br /></span>
                &nbsp;&nbsp;
                SD-WAN可基于互联网或已有的MPLS网络部署，终端接入设备即插即用，安装无需IT经验人员。
            </p>
            <p class="reveal-bottom">
                <span style="font-weight:bold"> 集中管理与监控：<br /></span>
                &nbsp;&nbsp;
                IT管理人员可登陆集中管理平台进行远程配置，无需到达现场。同时SD-WAN也提供了多手段的监控平台，随时获知网络状态。而且可以展示多维度的报表与曲线，方便IT人员提早规划扩容与缩减。
            </p>
            <p class="reveal-bottom">
                <span style="font-weight:bold"> 灵活的部署方式：<br /></span>
                &nbsp;&nbsp;
                SD-WAN支持多种途径组建网络。比如硬件CPE设备，虚拟化CPE服务，以及软件终端等，以解决不同网络环境下的灵活连接。
            </p>
            <p class="reveal-bottom">
                <span style="font-weight:bold"> 软件定义：<br /></span>
                &nbsp;&nbsp;
                通过集中控制平台可以方便地调整各个节点的拓扑结构，以及动态业务配置，甚至连接类型，最大地方便用户管理网络结构。
            </p>
            <h3 class="reveal-bottom">
                SD-WAN部署案例1——企业混合组网
            </h3>
            <img
                :src="img1"
                alt="img1"
                style="width:600px;"
                class="reveal-bottom"
            />
            <p class="reveal-bottom">
                该企业使用了OceanBlue Cloud提供的SD-WAN与MPLS混合组网方案。
            </p>
            <p class="reveal-bottom">
                MPLS网络依赖其低延迟高稳定的特点，承载了企业的核心业务（音视频在线会议）。
            </p>
            <p class="reveal-bottom">
                同时，SD-WAN提供了高性价比的线路，承载了其OA、ERP、文件共享等非实时，大带宽流量消耗的业务。
            </p>
            <p class="reveal-bottom">
                对于海外分支部门，由于MPLS网络覆盖与部署困难，也使用了SD-WAN网络较快速与稳定地加入了企业网。
            </p>
            <p class="reveal-bottom">
                而且，通过MPLS与SD-WAN网络进行互备配置，实现了网络的高可用。当MPLS故障时，其上的业务将自动切换到SD-WAN网络，反之亦然。因此该企业实现了较低廉的双线互备功能。
            </p>
            <h3 class="reveal-bottom">
                SD-WAN应用案例2——公有云应用加速
            </h3>
            <img
                :src="img2"
                alt="img1"
                style="width:600px;"
                class="reveal-bottom"
            />
            <p class="reveal-bottom">
                随着越来越多企业应用服务器部署在公有云，全球对公有云的加速访问需求越来越强烈。因此该企业部署如上图的公有云加速方案。该方案利用现有互联网出口，快速简易部署，加速部署在全球任何站点的的云应用（Saas服务，如阿里邮箱，Office365，Salesforce），解决访问云应用遭遇的网速过慢问题。
            </p>
            <p class="reveal-bottom">
                总之，SD-WAN技术将是专线方案的一个良好补充，为企业提供了一个快速、便捷的组网与加速服务。随着企业全球化的发展，SD-WAN技术将越来越受到各企业IT部门的青睐。
            </p>
        </DetailBody>
    </div>
</template>
<script>
import initAnimation from "../animation";
import DetailHeader from "./Header";
import DetailBody from "./Body";

export default {
    data() {
        return {
            img1: require("@/assets/images/new/2_0.png"),
            img2: require("@/assets/images/new/2_1.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        DetailHeader,
        DetailBody,
    },
};
</script>
<style scoped>
/* .box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
} */
.title {
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/NewDetail/N2.vue